"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetLazyComponentPublic = exports.WidgetLazyComponentLoader = void 0;
var tslib_1 = require("tslib");
var ExpressCheckoutWidget_1 = require("@wix/cashier-core/dist/src/services/ExpressCheckoutWidget");
var react_1 = tslib_1.__importDefault(require("react"));
var logger_1 = require("@wix/web-bi-logger/dist/src/logger");
var react_module_container_1 = require("react-module-container");
var constants_1 = require("../constants");
var InteractionName_1 = require("../types/InteractionName");
var perfNow_1 = require("../utils/perfNow");
var preloadData_1 = require("../utils/preloadData");
var constants_2 = require("./fedopsLogger/constants");
var createFedopsLogger_1 = require("./fedopsLogger/createFedopsLogger");
var config_1 = require("./config");
var minified_1 = require("./minified");
/**
 * @class WidgetLazyComponentLoader
 * Starts loading lazy component for Express Checkout Widget
 * to be able for us to change lazy component without Consumer
 * notification.
 */
var WidgetLazyComponentLoader = /** @class */ (function (_super) {
    tslib_1.__extends(WidgetLazyComponentLoader, _super);
    function WidgetLazyComponentLoader(props) {
        var _this = _super.call(this, props, {
            component: config_1.WIDGET_ID,
            files: WidgetLazyComponentLoader.buildFiles(props),
            crossorigin: true,
        }) || this;
        _this.props.fedopsLogger.appLoadingPhaseStart(InteractionName_1.PhaseName.LoadMainBundle);
        return _this;
    }
    WidgetLazyComponentLoader.buildFiles = function (props) {
        return [
            "".concat(props.widgetSettings.widgetStaticsBaseUrl).concat(constants_1.WIDGET_BUNDLE_FILE_NAME).concat((0, minified_1.minified)(), ".css"),
            "".concat(props.widgetSettings.widgetStaticsBaseUrl).concat(constants_1.WIDGET_BUNDLE_FILE_NAME, ".bundle").concat((0, minified_1.minified)(), ".js"),
        ];
    };
    return WidgetLazyComponentLoader;
}(react_module_container_1.ReactLazyComponent));
exports.WidgetLazyComponentLoader = WidgetLazyComponentLoader;
/**
 * @class WidgetLazyComponentPublic
 * Main exported component for TPA. The main idea to use it
 * is to fetch settings for e-widget and to start fedops
 * interactions if consumer didn't start it.
 */
var WidgetLazyComponentPublic = /** @class */ (function (_super) {
    tslib_1.__extends(WidgetLazyComponentPublic, _super);
    function WidgetLazyComponentPublic(props) {
        var _this = _super.call(this, props) || this;
        _this._isMounted = true;
        _this.state = {
            widgetSettings: null,
        };
        _this.fedopsLogger =
            typeof props.fedopsLoggerFactory === 'function'
                ? props.fedopsLoggerFactory(constants_2.FEDOPS_LOGGER_ID)
                : (0, createFedopsLogger_1.createFedopsLogger)();
        var _a = _this.props.meta, appInstanceId = _a.appInstanceId, siteId = _a.siteId, productId = _a.productId, visitorId = _a.visitorId;
        _this.fedopsLogger.appLoadStarted();
        _this.loaderStartTime = (0, perfNow_1.perfNow)();
        _this.biLoggerFactory = (0, logger_1.factory)({ endpoint: 'cashier-ugc' });
        _this.biLoggerFactory.logger().log({
            src: 64,
            evid: 261,
            appInstanceId: appInstanceId,
            currency: props.currency,
            msid: siteId,
            origin: props.domain,
            productId: productId,
            visitorId: visitorId,
        });
        return _this;
    }
    WidgetLazyComponentPublic.prototype.componentDidMount = function () {
        this.fetchPreloadData();
        this.fetchWidgetSettings();
    };
    WidgetLazyComponentPublic.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    WidgetLazyComponentPublic.prototype.fetchWidgetSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var widgetSettings, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.LoadWidgetSettings);
                        this.fedopsLogger.appLoadingPhaseStart(InteractionName_1.PhaseName.LoadSettings);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        // Saving fetchWidgetSettings to static prop is useful when
                        // component is re-rendered, so we don't need to request widget's meta info multiple times
                        WidgetLazyComponentPublic.fetchWidgetSettingsPromise =
                            WidgetLazyComponentPublic.fetchWidgetSettingsPromise ||
                                new ExpressCheckoutWidget_1.ExpressCheckoutWidgetService({
                                    baseURL: '/',
                                    appInstance: this.props.meta.appInstance,
                                    revalidateAppInstance: this.props.revalidateAppInstance,
                                }).fetchWidgetSettings();
                        return [4 /*yield*/, WidgetLazyComponentPublic.fetchWidgetSettingsPromise];
                    case 2:
                        widgetSettings = _a.sent();
                        this.fedopsLogger.interactionEnded(InteractionName_1.InteractionName.LoadWidgetSettings);
                        if (this._isMounted) {
                            this.setState({ widgetSettings: widgetSettings });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WidgetLazyComponentPublic.prototype.fetchPreloadData = function () {
        this.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.LoadExperiments);
        this.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.LoadPaymentMethods);
        this.preloadingData = (0, preloadData_1.preloadData)(this.props);
    };
    WidgetLazyComponentPublic.prototype.render = function () {
        var widgetSettings = this.state.widgetSettings;
        if (widgetSettings === null) {
            return null;
        }
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(WidgetLazyComponentLoader, tslib_1.__assign({}, this.props, { preloadingData: this.preloadingData, fedopsLogger: this.fedopsLogger, biLoggerFactory: this.biLoggerFactory, widgetSettings: widgetSettings, loadInfo: {
                    loadStartTime: this.loaderStartTime,
                } }))));
    };
    return WidgetLazyComponentPublic;
}(react_1.default.Component));
exports.WidgetLazyComponentPublic = WidgetLazyComponentPublic;
//# sourceMappingURL=WidgetLazyComponent.public.js.map